import type { Id } from "@convex/_generated/dataModel";

import { toConvexTableId } from "~/lib/convex-table-id";

interface TaxCategory {
  _id: Id<"taxCategories">;
  _creationTime: number;
  name: string;
  value: number;
  taxCode?: string;
  organizationId: Id<"organizations">;
}

export const taxCategoryDefault: TaxCategory = {
  _id: toConvexTableId("taxCategories", "taxcategories0000000001"),
  name: "Untaxed",
  value: 0,
  taxCode: undefined,
  _creationTime: 0,
  organizationId: toConvexTableId("organizations", "organizations000000001"),
};
